var _circle, _mask, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#5468FF"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "url(#paint0_linear)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 32.7712V35.5754C29 35.8912 28.7443 36.1469 28.4286 36.1469H7.57143C7.25571 36.1469 7 35.8912 7 35.5754V32.7712C7 29.829 9.385 27.4454 12.3279 27.4447C13.3679 27.444 14.2836 26.909 14.8107 26.0976C15.3403 25.2837 15.2857 24.576 15.2857 24.004L15.2964 23.9776C12.7321 22.9162 10.9286 20.3897 10.9286 17.4419V17.2183C9.91036 17.2183 9.14286 16.4137 9.14286 15.4654V12.4969C9.12 11.4633 9.16714 7.81829 11.8 5.28043C14.8614 2.32972 19.7129 2.57115 23.2271 4.14972C23.3414 4.20115 23.3379 4.36472 23.2221 4.41258L22.3057 4.78972C22.1686 4.84615 22.1979 5.04829 22.345 5.06401L22.79 5.11186C24.9207 5.33972 26.9 6.49686 28.1271 8.42258C28.16 8.47472 28.1507 8.55401 28.1086 8.59901C27.3514 9.39972 26.9286 10.4626 26.9286 11.5676V15.4654C26.9286 16.4333 26.1436 17.2183 25.1757 17.2183H25.0714V17.4419C25.0714 20.3897 23.2679 22.9162 20.7036 23.9776L20.7143 24.004C20.7143 24.5595 20.6552 25.2769 21.1893 26.0976C21.7164 26.909 22.6321 27.444 23.6721 27.4447C26.615 27.4454 29 29.829 29 32.7712Z",
    fill: "#FFDFBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 32.7714V35.5756C29 35.8912 28.7441 36.1471 28.4286 36.1471H7.57143C7.25586 36.1471 7 35.8912 7 35.5756V32.7714C7 29.8292 9.38536 27.446 12.3275 27.4449C13.3678 27.4446 14.2837 26.9089 14.8107 26.0978C16.6503 27.6694 19.3486 27.6703 21.1893 26.0978C21.7162 26.9089 22.6322 27.4446 23.6725 27.4449C26.6146 27.446 29 29.8292 29 32.7714Z",
    fill: "#00D9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1269 8.42302C28.1601 8.47509 28.1508 8.55395 28.1084 8.5988C27.3515 9.40009 26.9286 10.4626 26.9286 11.5677V15.4655C26.9286 16.3504 26.262 17.2184 25.0715 17.2184V12.8062C25.0715 10.9127 23.5365 9.37766 21.6429 9.37766H14.3572C12.4636 9.37766 10.9286 10.9127 10.9286 12.8062V17.2184C9.91042 17.2184 9.14292 16.4137 9.14292 15.4655V12.4969C9.12007 11.4634 9.16721 7.81837 11.8001 5.28052C14.8613 2.32973 19.7132 2.5713 23.2269 4.15002C23.3412 4.20137 23.3382 4.36502 23.2223 4.41273L22.3058 4.79002C22.1688 4.84644 22.1976 5.04837 22.3449 5.06416L22.7901 5.11194C24.9211 5.33959 26.8999 6.49673 28.1269 8.42302Z",
    fill: "#42434D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0714 17.4418C25.0714 21.3487 21.9037 24.5133 18 24.5133C14.322 24.5133 10.9286 21.6539 10.9286 17.2183V12.8061C10.9286 10.9126 12.4636 9.37756 14.3572 9.37756H21.6429C23.5364 9.37756 25.0714 10.9126 25.0714 12.8061V17.4418Z",
    fill: "#FFEBD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7857 34.9328H22.0714C21.7559 34.9328 21.5 34.677 21.5 34.3614C21.5 34.0458 21.7559 33.79 22.0714 33.79H23.7857C24.1013 33.79 24.3571 34.0458 24.3571 34.3614C24.3571 34.677 24.1014 34.9328 23.7857 34.9328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3989 22.0084C17.5615 22.7357 16.6447 24.5195 15.372 24.0087C12.7553 22.9584 10.9286 20.4084 10.9286 17.4421V12.8064C10.9286 12.0861 11.1507 11.4177 11.5302 10.8658C11.9954 10.1892 13.0714 10.4881 13.0714 11.3778V16.0135C13.0714 18.6214 14.4423 20.7842 16.3989 22.0084Z",
    fill: "#FFF3E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.795 25.1769C19.0352 25.9136 17.1012 25.9707 15.205 25.1769C15.3018 24.7751 15.2857 24.5148 15.2857 24.0041L15.2964 23.9777C17.0165 24.6917 18.98 24.6931 20.7035 23.9777L20.7142 24.0041C20.7142 24.515 20.6981 24.7752 20.795 25.1769Z",
    fill: "#FFD6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2059 29.1704C14.9417 29.2535 14.6584 29.2993 14.3547 29.3019C11.405 29.3279 9 31.6603 9 34.6101V35.1471C9 35.6994 8.55229 36.1471 8 36.1471H7.57143C7.25586 36.1471 7 35.8912 7 35.5756V32.7713C7 29.8291 9.38536 27.446 12.3275 27.4449C13.3678 27.4446 14.2837 26.9089 14.8107 26.0978C15.0231 26.2792 15.2506 26.4423 15.4901 26.5851C16.5439 27.213 16.376 28.8025 15.2059 29.1704Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7941 29.1704C21.0583 29.2535 21.3416 29.2993 21.6453 29.3019C24.595 29.3279 27 31.6603 27 34.6101V35.1471C27 35.6994 27.4477 36.1471 28 36.1471H28.4286C28.7441 36.1471 29 35.8912 29 35.5756V32.7713C29 29.8291 26.6146 27.446 23.6725 27.4449C22.6322 27.4446 21.7163 26.9089 21.1893 26.0978C20.9768 26.2792 20.7494 26.4423 20.5098 26.5851C19.4561 27.213 19.624 28.8025 20.7941 29.1704Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2222 4.4127C22.3824 4.75834 22.2626 4.83456 21.9716 4.78941C17.2806 4.06227 13.1649 6.0032 11.7672 10.5598V10.5606C11.2444 11.162 10.9286 11.9477 10.9286 12.8063V15.4865C10.9286 16.6428 9.14292 16.7233 9.14292 15.4656V12.497C9.12007 11.4634 9.16721 7.81841 11.8001 5.28056C14.8615 2.32984 19.7129 2.57127 23.2272 4.14984C23.3415 4.20127 23.3379 4.36484 23.2222 4.4127Z",
    fill: "#4D4E59"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 1.8,
    y1: 2.16,
    x2: 32.04,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8492FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5468FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 10.8139,
    y1: 28.8315,
    x2: 32.5264,
    y2: 49.1398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10CBF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 7.67396,
    y1: 12.8083,
    x2: 29.888,
    y2: 34.1726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10CBF0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.1031ebff.svg";
export { ForwardRef as ReactComponent };